import { useImperativeHandle, useRef } from 'react';
import css from './DataTable.module.scss';
import { durationDisplayValue, updateDurationValue } from './filtering';
import type { GridFilterInputValueProps } from './types';

export function DurationFilterInput({
  item,
  applyValue,
  focusElementRef,
}: GridFilterInputValueProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  useImperativeHandle(focusElementRef, () => ({ focus: () => inputRef.current?.focus() }));
  const value = durationDisplayValue(item);
  return (
    <div className={css.durationInput}>
      <input
        ref={inputRef}
        className={css.input}
        aria-label="Duration value"
        type="number"
        min="0"
        step="any"
        placeholder="Value"
        value={value}
        onInput={(event) => applyValue(updateDurationValue(item, event.currentTarget.value))}
      />
      <select
        className={css.input}
        aria-label="Duration unit"
        value={item.unitMultiplier ?? 1}
        onChange={(event) =>
          applyValue(updateDurationValue(item, value, Number(event.target.value)))
        }
      >
        <option value={1}>seconds</option>
        <option value={60}>minutes</option>
        <option value={3600}>hours</option>
      </select>
    </div>
  );
}
